import {
  Button,
  Modal,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useStytch, useStytchUser } from "@stytch/react";
import { useMutation } from "@tanstack/react-query";
import {
  AuthPasswordCreateForm,
  AuthPasswordCreateFormData,
} from "features/auth/password/AuthPasswordCreateForm";
import { getStytchSessionDurationMinutes } from "features/auth/StytchUtils";
import React from "react";
import { useTranslation } from "react-i18next";

export const AccountSecurityPassword: React.FC = () => {
  const { t } = useTranslation(["account", "auth", "common"]);

  const stytchClient = useStytch();
  const { user: stytchUser } = useStytchUser();
  const email = stytchUser!.emails[0].email;

  const {
    isOpen: isChangePasswordOpen,
    onOpen: openChangePassword,
    onClose: closeChangePassword,
  } = useDisclosure();

  const { mutateAsync: resetPassword, isPending } = useMutation({
    mutationFn: ({ password }: AuthPasswordCreateFormData) =>
      stytchClient.passwords.resetBySession({
        password,
        session_duration_minutes: getStytchSessionDurationMinutes(),
      }),
  });

  return (
    <>
      <Button colorScheme="secondary" onClick={openChangePassword}>
        {t("account:security.password.change")}
      </Button>
      <Modal
        isOpen={isChangePasswordOpen}
        onClose={closeChangePassword}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <AuthPasswordCreateForm
            email={email}
            onSubmit={resetPassword}
            onSuccess={closeChangePassword}
            onCancel={closeChangePassword}
            isLoading={isPending}
            successMessage={t("account:security.password.changeSuccess")}
          />
        </ModalContent>
      </Modal>
    </>
  );
};
